import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateParsePipe } from './date-parse.pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DateParsePipe],
  imports: [CommonModule, TranslateModule.forChild()],
  exports: [DateParsePipe],
})
export class DateParseModule {}
